/** Build evidence accept payload for Tier 1 linking on review accept. */

export function buildEvidenceAcceptPayload(preview, reviewJobId, evidenceQuote) {
  const quote = String(evidenceQuote || "").trim();
  if (!quote) {
    return {};
  }
  const ev = preview?.evidence || {};
  const ingestion_run_id =
    ev.ingestion_run_id || ev.primary_ingestion_run_id || null;
  const job_id = String(reviewJobId || preview?.job_id || "").trim() || null;
  const anchor_entity_id =
    preview?.anchor_application_id || preview?.anchor_entity_id || null;
  return {
    evidence: {
      evidence_quote: quote,
      ingestion_run_id,
      job_id,
      anchor_entity_id,
    },
  };
}

/** Prefer row evidence_quote, then nested evidence, then rationale as last resort. */
export function evidenceQuoteFromRow(row) {
  const direct = String(row?.evidence_quote || "").trim();
  if (direct) return direct;
  const nested = String(row?.evidence?.evidence_quote || "").trim();
  if (nested) return nested;
  return String(row?.rationale || "").trim();
}
